















import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * The states a screen's body passes through, in one place: loading, then a failure, then "nothing
 * here", then the content (the default slot). Each text comes translated, and an empty one means the
 * state does not apply, so a screen passes e.g. `:empty="rows.length === 0 ? $t('…') : ''"`.
 *
 * **Pass the content as `<template v-slot:default>`**, never as plain children: Vue 2 evaluates plain
 * slot content even while it is not shown, so content reading data that is not loaded yet
 * (`detail.problems` while `detail` is null) throws during loading and the whole page renders blank.
 * A `v-slot` template is evaluated only when the slot is rendered.
 *
 * Written down in `.claude/rules/ui-conventions.md` ("Page states").
 */
@Component
export default class ContentStateComponent extends Vue {
  @Prop({ default: false })
  loading!: boolean;

  /** Said under the spinner where the wait can be long (a whole file), translated; optional. */
  @Prop({ default: "" })
  loadingText!: string;

  /** Why loading failed, translated; empty when it did not. */
  @Prop({ default: "" })
  error!: string;

  /** What is missing, translated; empty when there is content. */
  @Prop({ default: "" })
  empty!: string;
}
